import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from "../../services/axiosInstance";
import {
    fetchRackListMove
} from "../pages/dashboard/dashboardSlice";

export default function RackDetailModal({ rack, data, onClose }) {

    const [showMove, setShowMove] = useState(false);
    //const [rackList, setRackList] = useState([]);
    const dispatch = useDispatch();

    const [showForm, setShowForm] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [formData, setFormData] = useState({
        id: null,
        racking_id: rack?.id || '',
        level_code: '',
        kode_palet: '',
        sku: '',
        batch_no: '',
        qty: ''
    });

    {/*const openAddForm = () => {
        setIsEdit(false);

        setFormData({
            id: null,
            racking_id: rack.id,
            level_code: rack.level_code || '',
            kode_palet: '',
            sku: '',
            batch_no: '',
            qty: ''
        });

        setShowForm(true);
    };*/}

    {/*const openEditForm = (item) => {
        setIsEdit(true);

        setFormData({
            id: item.id,
            racking_id: item.racking_id,
            level_code: item.level_code,
            kode_palet: item.kode_palet,
            sku: item.sku,
            batch_no: item.batch_no,
            qty: item.qty
        });

        setShowForm(true);
    };*/}

    const saveItem = async () => {
        try {

            if (isEdit) {
                await axios.put(
                    `/dashracking/detail/${formData.id}`,
                    formData
                );
            } else {
                await axios.post(
                    `/dashracking/detail`,
                    formData
                );
            }

            alert(
                isEdit
                    ? 'Data berhasil diubah'
                    : 'Data berhasil ditambahkan'
            );

            setShowForm(false);

            setTimeout(() => {
                window.location.reload();
            }, 500);

        } catch (err) {

            alert(
                err.response?.data?.message ||
                'Gagal menyimpan data'
            );

        }
    };

    const rackListMove = useSelector(
        state => state.dashboard.rackListMove
    );

    const [moveData, setMoveData] = useState({
        detail_id: null,
        rack_code: '',
        level_code: ''
    });

    const saveMove = async () => {

       try {

        const response = await axios.post(
            '/dashracking/move-location',
            moveData
        );

           setTimeout(() => {
               window.location.reload();
           }, 500);

        //console.log('SUCCESS', response.data);

        alert('Berhasil dipindah');

        setShowMove(false);

    } catch (err) {

        //console.log('ERROR FULL', err);

        //console.log('ERROR RESPONSE', err.response);

        //console.log('ERROR DATA', err.response?.data);

        //console.log('ERROR MESSAGE', err.message);

        alert(
            err.response?.data?.message ||
            'Gagal memindahkan lokasi'
        );

    }
    };

    useEffect(() => {
        if (showMove) {
            dispatch(fetchRackListMove());
        }
    }, [showMove, dispatch]);

    const isExpired = (date) => {
        return new Date(date) < new Date();
    };

    if (!rack) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white w-[600px] rounded-2xl shadow-lg p-6">

                {/* HEADER */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="font-bold text-lg">
                        Rack Detail  - {rack.level_code}
                    </h2>
                    <button onClick={onClose} className="text-red-500">X</button>
                </div>

                {/*<div className="flex gap-2 justify-end mb-4">
                    <button
                        onClick={openAddForm}
                        className="bg-green-600 text-white px-3 py-1 rounded"
                    >
                        + Tambah
                    </button>
                </div>*/}

                {/* CONTENT */}
                {!data ? (
                    <div>Loading...</div>
                ) : (
                    <div className="space-y-3 max-h-[400px] overflow-auto">
                        {data.map((item, i) => (
                            <div
                                key={i}
                                className={`border p-3 rounded ${isExpired(item.due_date) ? "bg-red-100" : ""}`}
                            >
                                <div className="flex justify-between">
                                    <div className="font-semibold">{item.sku} - {item.name_product}</div>
                                    <span className="text-xs bg-blue-100 px-2 rounded">
                                        {item.kode_palet}
                                    </span>
                                </div>

                                <div className="text-xs">Kode Palet: {item.kode_palet}</div>
                                <div className="text-xs">Lot Number: {item.batch_no}</div>
                                <div className="text-xs">Qty: {item.qty}</div>
                                <div className="text-xs">Exp: {item.due_date}</div>
                                <div className="text-xs">
                                    <button
                                        className="mt-2 bg-blue-500 text-white px-3 py-1 rounded"
                                        onClick={() => {
                                            setMoveData({
                                                detail_id: item.id,
                                                rack_code: '',
                                                level_code: item.level_code || ''
                                            });

                                            setShowMove(true);
                                        }}
                                    >
                                        Move
                                    </button>

                                    {/*<button
                                        className="mt-2 ml-2 bg-yellow-500 text-white px-3 py-1 rounded"
                                        onClick={() => openEditForm(item)}
                                    >
                                        Edit
                                    </button>*/}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {
                    showMove && (
                        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
                            <div className="bg-white p-5 rounded-xl w-[400px]">

                                <h3 className="font-bold mb-4">
                                    Move Location
                                </h3>

                                <div className="mb-3">
                                    <label>Rack Tujuan</label>

                                    <select
                                        className="border w-full p-2 rounded"
                                        value={moveData.rack_code}
                                        onChange={(e) =>
                                            setMoveData({
                                                ...moveData,
                                                rack_code: e.target.value
                                            })
                                        }
                                    >
                                        <option value="">
                                            Pilih Rack
                                        </option>

                                        {rackListMove.map((rack) => (
                                            <option
                                                key={rack.id}
                                                value={rack.code}
                                            >
                                                [{rack.warehouse_name}] {rack.code} - {rack.racks_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label>Level Tujuan</label>

                                    <input
                                        type="text"
                                        className="border w-full p-2 rounded"
                                        value={moveData.level_code}
                                        onChange={(e) =>
                                            setMoveData({
                                                ...moveData,
                                                level_code: e.target.value
                                            })
                                        }
                                    />
                                </div>

                                <div className="flex justify-end gap-2">
                                    <button
                                        className="px-3 py-2 border rounded"
                                        onClick={() => setShowMove(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="px-3 py-2 bg-green-600 text-white rounded"
                                        onClick={saveMove}
                                    >
                                        Save
                                    </button>
                                </div>

                            </div>
                        </div>
                    )
                }

                {
                    showForm && (
                        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[70]">

                            <div className="bg-white p-5 rounded-xl w-[500px]">

                                <h3 className="font-bold mb-4">
                                    {isEdit ? 'Edit Item' : 'Tambah Item'}
                                </h3>

                                <div className="space-y-3">

                                    <input
                                        className="border w-full p-2 rounded"
                                        placeholder="Racking ID"
                                        value={formData.racking_id}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                racking_id: e.target.value
                                            })
                                        }
                                    />

                                    <input
                                        className="border w-full p-2 rounded"
                                        placeholder="Level Code"
                                        value={formData.level_code}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                level_code: e.target.value
                                            })
                                        }
                                    />

                                    <input
                                        className="border w-full p-2 rounded"
                                        placeholder="Kode Palet"
                                        value={formData.kode_palet}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                kode_palet: e.target.value
                                            })
                                        }
                                    />

                                    <input
                                        className="border w-full p-2 rounded"
                                        placeholder="SKU"
                                        value={formData.sku}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                sku: e.target.value
                                            })
                                        }
                                    />

                                    <input
                                        className="border w-full p-2 rounded"
                                        placeholder="Batch No"
                                        value={formData.batch_no}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                batch_no: e.target.value
                                            })
                                        }
                                    />

                                    <input
                                        type="number"
                                        className="border w-full p-2 rounded"
                                        placeholder="Qty"
                                        value={formData.qty}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                qty: e.target.value
                                            })
                                        }
                                    />

                                </div>

                                <div className="flex justify-end gap-2 mt-4">

                                    <button
                                        className="border px-3 py-2 rounded"
                                        onClick={() => setShowForm(false)}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        className="bg-blue-600 text-white px-3 py-2 rounded"
                                        onClick={saveItem}
                                    >
                                        Save
                                    </button>

                                </div>

                            </div>

                        </div>
                    )
                }
            </div>
        </div>
    );
}